//containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '@/containers-m/Navigation';

//styles
import { Layout, PageWrapper, ContainerStyled } from './ThankYou.styles';

import { Paragraph2, Title2 } from '@/components/Text';
import { MirandaBrandButton } from '@/components/Button';

const Calendar = () => {
  return (
    <PageWrapper>
      <Navigation />
      <Layout>
        <ContainerStyled>
          <Title2>A calendar should appear so you can book your demo.</Title2>
          <Paragraph2>
            If it doesn’t, no worries — a member of our team will reach out
            shortly.
          </Paragraph2>
          <br />
          <MirandaBrandButton as="a" href="/">
            Return to the homepage
          </MirandaBrandButton>
        </ContainerStyled>
      </Layout>

      <Footer />
    </PageWrapper>
  );
};

export default Calendar;
export { Calendar };
